import React from 'react';
import { FaFileCode } from 'react-icons/fa';
import { GrContact } from 'react-icons/gr';
import { GiGraduateCap } from 'react-icons/gi';
import { MdWorkHistory } from 'react-icons/md';
import { IoMdFingerPrint } from 'react-icons/io';

export const sidebarData = [
  {
    href: 'about_me',
    icon: <IoMdFingerPrint className="side-nav__link--icon" />,
  },
  {
    href: 'experience_education',
    icon: (
      <div className="custom-icon-container">
        <MdWorkHistory className="briefcase-icon side-nav__link--icon" />
        <GiGraduateCap className="graduation-icon" />
      </div>
    ),
  },
  { href: 'projects', icon: <FaFileCode className="side-nav__link--icon" /> },
  { href: 'contact', icon: <GrContact className="side-nav__link--icon" /> },
];
